import React from 'react';

interface AlfaGptMenuIconProps {
  className?: string;
  size?: number;
  aiColor?: string;
}

const AlfaGptMenuIcon: React.FC<AlfaGptMenuIconProps> = ({
  className = '',
  size = 20,
  aiColor = '#ffffff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.25251 12.3662C-0.471244 7.46125 3.17001 2.32375 8.37 2.325C8.5898 2.325 8.8006 2.41231 8.95602 2.56773C9.11144 2.72315 9.19875 2.93395 9.19875 3.15375C9.19875 3.37355 9.11144 3.58434 8.95602 3.73976C8.8006 3.89518 8.5898 3.9825 8.37 3.9825C4.17625 3.9825 1.32751 8.245 2.93251 12.1175C4.53751 15.9925 9.56501 16.9925 12.53 14.0262C13.5388 13.0204 14.1466 11.6815 14.24 10.26C14.2429 10.1484 14.2684 10.0385 14.3148 9.93701C14.3612 9.83548 14.4277 9.74439 14.5102 9.66919C14.5927 9.59399 14.6896 9.53623 14.795 9.49939C14.9004 9.46255 15.0121 9.44738 15.1235 9.4548C15.2349 9.46221 15.3437 9.49206 15.4432 9.54254C15.5428 9.59303 15.6312 9.66311 15.703 9.74858C15.7748 9.83405 15.8286 9.93316 15.8612 10.0399C15.8937 10.1467 15.9044 10.259 15.8925 10.37C15.792 11.906 15.2216 13.374 14.2588 14.575L17.1338 17.4075C17.2812 17.5635 17.3624 17.7707 17.3601 17.9853C17.3579 18.2 17.2725 18.4054 17.1218 18.5584C16.9711 18.7113 16.767 18.7998 16.5524 18.8052C16.3378 18.8107 16.1295 18.7326 15.9713 18.5875L13.0863 15.7475C9.03125 19.0012 2.97751 17.2725 1.25251 12.3662Z"
        fill="currentColor"
      />
      <path
        d="M13.3158 1.71894C13.3494 1.68693 13.3936 1.66834 13.44 1.66667H13.4613C13.5072 1.66712 13.5513 1.68464 13.5851 1.71583C13.6188 1.74702 13.6397 1.78965 13.6438 1.83542C13.7172 2.63071 14.0657 3.37547 14.6293 3.94136C15.1929 4.50724 15.9363 4.85879 16.7313 4.93542C16.7753 4.94174 16.8156 4.96374 16.8448 4.99738C16.8739 5.03101 16.89 5.07403 16.89 5.11855C16.89 5.16306 16.8739 5.20608 16.8448 5.23972C16.8156 5.27335 16.7753 5.29535 16.7313 5.30167C15.9379 5.38002 15.1963 5.73149 14.6334 6.29602C14.0705 6.86055 13.7211 7.60308 13.645 8.39667C13.6363 8.49167 13.5575 8.56667 13.4613 8.56667H13.4438C13.3488 8.56792 13.2688 8.49542 13.2613 8.40042C13.1854 7.60588 12.8355 6.86249 12.2714 6.29777C11.7074 5.73305 10.9644 5.38221 10.17 5.30542C10.075 5.29667 10.0013 5.21792 10 5.12167C9.99982 5.07596 10.0168 5.03184 10.0476 4.99805C10.0784 4.96425 10.1207 4.94324 10.1663 4.93917C10.9608 4.86109 11.7036 4.50933 12.2675 3.94408C12.8314 3.37883 13.1813 2.6352 13.2575 1.84042C13.2614 1.79417 13.2822 1.75095 13.3158 1.71894Z"
        fill={aiColor}
      />
    </svg>
  );
};

export default AlfaGptMenuIcon;
